import MovedPage from './MovedPage';

export default MovedPage;
